import { contentTagging } from '../../onbrand.js';
import { twitterImageUpdate } from '../twitterTiles.js';
const { stickyHubNav } = require('./hubNav');
const helper = require('../helperFunctions.js');
const { searchClose } = require('../tileCustomization.js');
const { twitterRSS } = require('../twitterRSS');
module.exports = function englishPartial() {
    // custom Hub functions

    let englishLoaded = false;

    Hubs.Events
        .on('load', () => {
            if (!englishLoaded) {
                // Call all on load functions here
                twitterImageUpdate();
                stickyHubNav();
                twitterRSS();
                englishLoaded = true;
            }
        })
        .on('itemsLoaded', (itemIds, selectors) => {
            // Call all itemsLoaded events here
            twitterImageUpdate();
        })
        .on('resize', () => {
            // Call all resize events here
        })
        .on('scroll', () => {
            // Call all scroll events here
            stickyHubNav();
        })
        .on('ctaActivate', (ctaId) => {
            // Call all ctaActivate events here
        })
        .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {
            // Call all ctaFormSubmitSuccess events here
        });
};


// WEBPACK FOOTER //
// ./scriptPartials/hubSpecificFunctions/_english.js